import { render, staticRenderFns } from "./Mentor.vue?vue&type=template&id=64b8b47c&"
import script from "./Mentor.vue?vue&type=script&lang=js&"
export * from "./Mentor.vue?vue&type=script&lang=js&"
import style0 from "./Mentor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports